import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';

var useParentSelect = function useParentSelect() {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      parentSelected = _useState2[0],
      setParentSelected = _useState2[1];

  return {
    parentSelected: parentSelected,
    setParentSelected: setParentSelected
  };
};

export default useParentSelect;